import { formatReportDateUnix } from "@entities/history";
import { FixedAccordion } from "@shared/ui/fixed-accordion";
import { ReportInspectionsProps } from "./types";
import classes from "./report-inspections.module.scss";

export const ReportInspections = ({
    inspections = [],
    isPdfMode = false
}: ReportInspectionsProps) => {
    const emptyInspections = inspections.length < 1;

    return (
        <div className={classes.inspections}>
            {emptyInspections ? (
                <div className={classes.inspections__row}>Данные о техосмотрах не найдены</div>
            ) : (
                inspections?.map((item, index) => {
                    return (
                        <FixedAccordion
                            key={index}
                            expanded={isPdfMode}
                            title={
                                <div className={classes.inspections__title}>
                                    <div className={classes.inspections__date}>
                                        {formatReportDateUnix(item.startDate)}
                                    </div>
                                    {item.mileage.toLocaleString()} км
                                </div>
                            }
                            content={
                                <div className={classes.inspections__details}>
                                    <div className={classes.inspections__row}>
                                        <div className={classes.inspections__label}>Пробег</div>
                                        {item.mileage.toLocaleString()} км
                                    </div>
                                </div>
                            }
                        />
                    );
                })
            )}
        </div>
    );
};